import { render, staticRenderFns } from "./viewDashboard.vue?vue&type=template&id=72f852c3&scoped=true"
import script from "./viewDashboard.vue?vue&type=script&lang=js"
export * from "./viewDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f852c3",
  null
  
)

export default component.exports